import { render, staticRenderFns } from "./FinalTest.vue?vue&type=template&id=256b17d6&scoped=true"
import script from "./FinalTest.vue?vue&type=script&lang=js"
export * from "./FinalTest.vue?vue&type=script&lang=js"
import style0 from "./FinalTest.vue?vue&type=style&index=0&id=256b17d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b17d6",
  null
  
)

export default component.exports